import { useAppSelector } from "../../app/hooks";
import { selectHotel } from "../../features/hotel/hotelSlice";
import { formatCurrency } from "../../helpers/currency";

interface IFormatPrice {
  price: number;
  competitorPrice?: boolean;
  discountedPrice?: boolean;
  noNan?: boolean;
}

export default function FormatPrice({
  price = 0,
  competitorPrice = false,
  discountedPrice = false,
  noNan = false,
}: IFormatPrice) {
  const hotel = useAppSelector(selectHotel);
  let calculatedPrice = price;

  // Handle NaN values if noNan is true
  if(noNan && isNaN(calculatedPrice)) {
    return <></>;
  }

  // Show competitor price if applicable
  if (competitorPrice) {
    calculatedPrice = price * hotel.CompetitorPriceRelativeAdjustment;
  }

  // Calculate discounted price if applicable
  if (discountedPrice && !competitorPrice) {
    calculatedPrice = price - price * hotel.CompetitorPriceRelativeAdjustment;
  }

  return <span>{formatCurrency(calculatedPrice)}</span>;
}
